/**
 * Pin path for use as an inline svg that Google Maps will render.
 */
const routePinPath = `
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <g filter="url(#filter0_d_4931_64313)">
    <rect x="6" y="4" width="28" height="28" rx="14" fill="${VisitWidget.settings.currentClientRouteColor}" shape-rendering="crispEdges"/>
    <rect x="5" y="3" width="30" height="30" rx="15" stroke="white" stroke-width="2" shape-rendering="crispEdges"/>
  </g>
  <defs>
    <filter id="filter0_d_4931_64313" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="2"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4931_64313"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4931_64313" result="shape"/>
    </filter>
  </defs>
</svg>
`;

export { routePinPath };
